<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="2"> </v-col>
      <v-col cols="12" sm="12" md="8">
        <v-card class="mx-auto my-5 mb-16" max-width="1000">
          <v-app-bar flat>
            <span class="headline">{{ formCompData.title }}</span>
          </v-app-bar>
          <v-card-text>
            <v-container>
              <formComponent
                ref="formComponent"
                :form="formComp"
                v-model="formComp.eventForm"
              />
            </v-container>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click="saveForm(false)" data-cy="saveEvent">
              <div>
                {{ $t("general.save") }}
              </div>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="2"> </v-col>
    </v-row>
  </div>
</template>

<script>
function getDefaultData() {
  return {
    name: "",
    date: new Date(),
    description: "",
    wound: "",
    firstAid: false,
    nameFirstAid: "",
    med: false,
    medUsed: "",
  };
}
import formComponent from "../../components/_utils/formComponent/formComponent.vue";
import i18n from "../../i18n";
import { getUniqueId } from "../../components/api/api";
export default {
  components: { formComponent },
  props: ["data"],
  data: () => ({
    formCompData: {
      title: "medkitlogs.createMedkitlog",
      item: null,
    },
    formComp: {
      eventForm: getDefaultData(),
      form: [
        [
          {
            //v-text-field
            cols: 12,
            sm: 8,
            md: 8,
            class: "pb-0 pt-0",
            id: getUniqueId(),
            componentName: "vTextField",
            config: {
              vModel: "name",
              label: i18n.t("medkitlogs.employeeName"),
              dataCy: "name",
              rules: [(v) => !!v || i18n.t("general.fieldNeedsToBeFilled")],
            },
          },
          {
            cols: 12,
            sm: 4,
            md: 4,
            class: "pb-0 pt-0",
            id: getUniqueId(),
            componentName: "incidentReportDate",
            config: {},
          },
        ],
        [
          {
            cols: 12,
            sm: 6,
            md: 6,
            class: "pb-0",
            id: getUniqueId(),
            componentName: "vTextarea",
            config: {
              vModel: "wound",
              label: i18n.t("incidentReports.fields.injuryType"),
              dataCy: "wound",
              rules: [(v) => !!v || i18n.t("general.fieldNeedsToBeFilled")],
            },
          },
          {
            cols: 12,
            sm: 6,
            md: 6,
            class: "pb-0",
            id: getUniqueId(),
            componentName: "vTextarea",
            config: {
              vModel: "description",
              label: i18n.t("incidentReports.fields.incidentCourse"),
              dataCy: "description",
            },
          },
        ],
        [
          {
            cols: 12,
            sm: 6,
            md: 6,
            class: "pb-0 pt-3",
            id: getUniqueId(),
            componentName: "vTextField",
            config: {
              vModel: "personalId",
              label: i18n.t("incidentReports.fields.personnelId"),
              dataCy: "personalId",
            },
          },
        ],
        [
          {
            cols: 12,
            sm: 12,
            md: 12,
            class: "pb-0",
            id: getUniqueId(),
            componentName: "medkitlogFirstAid",
            config: {},
          },
        ],
        [
          {
            cols: 12,
            sm: 12,
            md: 12,
            class: "pb-0",
            id: getUniqueId(),
            componentName: "medkitlogNameFirstAid",
            config: {},
          },
        ],
        [
          {
            cols: 12,
            sm: 12,
            md: 12,
            class: "pb-0",
            id: getUniqueId(),
            componentName: "medkitlogMed",
            config: {},
          },
        ],
        [
          {
            cols: 12,
            sm: 12,
            md: 12,
            class: "pb-0",
            id: getUniqueId(),
            componentName: "medkitlogMedUsed",
            config: {},
          },
        ],
      ],
    },
  }),
  mounted() {
    this.formCompData.title = this.$t("medkitlogs.createMedkitlog");
  },
  methods: {
    async saveForm() {
      if (this.$refs.formComponent.validateAllFields()) {
        try {
          const response = await this.$store.dispatch(
            "createMedkitlogByQrCode",
            {
              qrCodeKey: this.$route.query.key,
              medkitlog: this.formComp.eventForm,
            }
          );
          console.log("Speichern erfolgreich", response);
          this.$emit("saveSuccess");
          this.resetData();
        } catch (err) {
          console.log("Fehler beim Speichern", err);
          this.$emit("saveFailure");
        }
      }
    },
    openDialog(val) {
      this.occupiedDialog.open = true;
      this.occupiedDialog.events = val;
    },
    resetData() {
      //reset whole form data
      this.formComp.eventForm = getDefaultData();
      this.$refs.formComponent.resetForm();
    },
    // reloadData() {
    //   this.$emit("reloadData");
    // },
  },
};
</script>
